var $ = jQuery;

var Accordion = require("./lib/Accordion.js");

var accordion;

var done = false;

function go() {
	if (!done) {
		done = true;
		
		var $container = $('.video-meta').first();
		
		var totalHeight = $container.height();
		var titleHeights = 0;
		$container.find('.video-meta--title__js').each(function(){
			titleHeights += $(this).outerHeight(true);
		});
		$persons = $container.find('.video-meta--content-persons__js').first();
		var personHeight = $persons.height();
		$persons.height(personHeight);
		
		var $description = $container.find('.video-meta--content-description__js').first();
		$description.height(totalHeight - titleHeights - personHeight);
		
		var $readMore = $container.find('.video-meta--content-description-read-more__js').first();
		
		if ($container.find('.video-meta--content-description-inner-overview').height() < $description.height()) {
			$readMore.hide();
		}
		
		accordion = new Accordion({
			$container:$container,
			titleSelector:'.video-meta--title__js',
			contentSelector:'.video-meta--content-description__js, .video-meta--content-persons__js',
			contentOpenedClass:'video-meta--content__open',
			titleOpenedClass:'video-meta--title__open'
		});
		accordion.onOpenCallback = function(idx) {
			$readMore.hide();
		};
		accordion.init();
		
		$container.on('click','.video-meta--content-description-read-more__js',function(e){
			e.preventDefault();
			accordion.open(0);
		});
		
		setTimeout(function(){
			$container.removeClass('video-meta__hidden');
		},5);
	}
}

module.exports = go;